module.exports = __webpack_public_path__ + "8cc20e21850f218bcaef723edfcf9e83.png";